import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const bookingEntity: Entity = {
  model: model,
  repository: repository,
}

export default bookingEntity
